export function GlobalStateProvider({ children }) {
    return children;
}
//# sourceMappingURL=GlobalStateProvider.js.map